export const serverconfigs = {
  appConfigUrl: "/app/config/",
  bbNewUploadUrl: "/balance-billing/beneficiary",
  favoriteProviderUrl: "/provider/favorite",
  fetchAllClaimsUrl: "balance-billing/claims/by-patient-id",
  fetchBalanceBillingClaimStatusUrl: "/balance-billing/status",
  fetchBalanceBillingHistoryForUserUrl: "/balance-billing/history",
  fetchBBClaimDetailsUrl: "/balance-billing/claim",
  fetchDocumentTypesUrl: "/balance-billing/document-types",
  fetchMyPlansDocumentsUrl: "/document-management/user/list-document",
  fetchQualityScoreCategoriesUrl: "/provider/quality-score",
  fetchUserInfoUrl: "/balance-billing/userInfo",
  fetchProviderTypeUrl: "/provider/provider-type",
  fetchProviderSpecialityUrl: "/provider/specialty",
  fetchProviderSpecialitiesUrl: "/provider/specialties",
  fetchProvidersUrl: "/provider/search",
  oneTimeSignatureAddressesUrl: "/one-time-signature/patient",
  fetchProcedureDetailsUrl: "/procedure-shopper/procedure",
  fetchProcedureQuestionnaireUrl: "/procedure-shopper/questionnaire",
  fetchProviderUrl: "/provider/detail",
  submitContactInformationUrl: "/balance-billing/contact",
  submitDAFUrl: "/one-time-signature/upload",
  submitFeedbackUrl: "/provider/feedback",
  submitProcedureShopperUrl: "/procedure-shopper/detail",
  submitUpdatedAddressUrl: "/one-time-signature/update-address",
  fetchTelemedicineUrl: "/telemedicine",
  fetchGroupSpecificContractsUrl: "/provider/contract-status?clientGroupId=",
  drexiSessionId: "/drexi/login",
  canImpersonate:"/register/can-impersonate",
  getImpersonatedUserToken:"/register/get-impersonated-user-token/"

};
